import { useState, useCallback, useRef } from 'react';
import { GetToken } from '@utils/storage';
import * as config from '@config';

function useFlightDealBook() {
    const [submitting, setSubmitting] = useState(false);
    const abortRef = useRef();

    const bookFlightDeal = useCallback(async (req) => {
        abort();
        abortRef.current = new AbortController();
        setSubmitting(true);
        try {
            const response = await fetch(`${config.apiURL2}/flight-deals/book`, {
                signal: abortRef.current.signal,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${GetToken()}`,
                },
                body: JSON.stringify(req),
            });
            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.error || 'Something went wrong when booking deal');
            }
            const data = await response.json();
            return data;
        } catch (error) {
            if (error.name === 'AbortError') {
                console.log('Request was aborted');
                throw new Error('Request was aborted');
            } else {
                console.error('Error book deal:', error);
            }
            throw error;
        } finally {
            setSubmitting(false);
        }
    }, []);

    const abort = useCallback(() => {
        if (abortRef.current) {
            abortRef.current.abort();
        }
    }, []);

    return { submitting, bookFlightDeal, abort };
}

export default useFlightDealBook;
